import React from 'react';
import {Line, defaults} from "react-chartjs-2";
import {lineChartTransformer} from "../../module/services/chart.transformer";

const LineChart = (props) => {
    defaults.global.defaultFontFamily = 'iranyekan';
    const options = {
        maintainAspectRatio: false,
        legend: {
            display: false,
        },
        tooltips: {
            backgroundColor: "#f5f5f5",
            titleFontColor: "#333",
            bodyFontColor: "#666",
            bodySpacing: 4,
            xPadding: 12,
            mode: "nearest",
            intersect: 0,
            position: "nearest",
        },
        responsive: true,
        scales: {
            yAxes: [
                {
                    display: true,

                    barPercentage: 1.2,
                    gridLines: {
                        drawBorder: true,
                        color: "rgba(29,140,248,0.1)",
                    },
                    ticks: {
                        suggestedMin: 0,
                        padding: 20,
                        fontColor: "#000",
                        fontSize: 13
                    },
                    scaleLabel: {
                        display: false,
                        labelString: 'مقدار',
                        fontColor:"rgb(36,36,36)"

                    },
                },
            ],
            xAxes: [
                {
                    display: true,
                    barPercentage: 1.2,
                    gridLines: {
                        drawBorder: false,
                        color: "rgba(29,140,248,0.1)",

                    },
                    ticks: {
                        padding: 40,
                        fontColor: "#000",
                        fontSize: 13
                    },
                    scaleLabel: {
                        display: false,
                        labelString: 'سال',
                        fontColor:"rgb(36,36,36)"
                    },
                },
            ],
        },
    };
    return (
        <Line
            data={lineChartTransformer(props.datasets,props.label)}
            redraw={true}
            options={options}
        />
    );
}

export default LineChart;